import { PermissionEnum } from "../../../common/permissions/permissions.Enum";
import { getGroupPermissionFactory } from "../../../common/permissions/permissions.utils";
import {
  getUtilityManagementModuleName,
} from "./utility-management.permissions";

export class AttachmentsPermissions {
  static GroupName = `${getUtilityManagementModuleName()}.Attachments`;

  static getPermissions = getGroupPermissionFactory(AttachmentsPermissions.GroupName);

  static Permissions = {
    Create: AttachmentsPermissions.getPermissions(PermissionEnum.CREATE),
    Read: AttachmentsPermissions.getPermissions(PermissionEnum.READ),
  };
}
